const runtimeConfig = typeof window !== 'undefined' && window.__APP_CONFIG__;

const buildTimeConfig = {
  apiBaseUrl: process.env.REACT_APP_APIBASEURL,
  appUrl: process.env.REACT_APP_APP_URL,
  rcApiBaseUrl: process.env.REACT_APP_RINGCENTRAL_API_BASE_URL,
  rcApiInternalUrl: process.env.REACT_APP_RCAPIINTERNALURL,
  rc_client_Id: process.env.REACT_APP_RINGCENTRAL_CLIENT_ID,
  rc_authorize_uri: process.env.REACT_APP_RINGCENTRAL_AUTHORIZE_URI,
  voicemailNumber: process.env.REACT_APP_VOICEMAIL_NUMBER,
  redirectRoute: process.env.REACT_APP_REDIRECT_ROUTE,
};

const config = {
  ...buildTimeConfig,
  ...(runtimeConfig || {}),
};

export default config;
